import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from '../../../common/components/runtime-context';
import { Helmet } from 'react-helmet';
import { ITEM_TYPES } from '@wix/advanced-seo-utils/api';
import { isSite } from '../../../common/store/basic-params/basic-params-selectors';

export const PageMetadata = ({
  title,
  description,
  image,
  video,
  entity,
  entityType,
  isSite,
  renderSEOTags,
  refersTo,
  paging,
}) => {
  return (
    <Helmet
      onChangeClientState={() => {
        if (!isSite) {
          return;
        }
        const itemType =
          entityType === 'category' ? ITEM_TYPES.FORUM_CATEGORY : ITEM_TYPES.FORUM_POST;

        const itemData = {
          [entityType]: {
            ...entity,
            title,
            description,
            images: image ? [image] : [],
            videos: video ? [video] : [],
            refersTo,
          },
          paging,
        };

        renderSEOTags({ itemType, itemData });
      }}
    />
  );
};

PageMetadata.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.object,
  video: PropTypes.object,
  isSite: PropTypes.bool,
  renderSEOTags: PropTypes.func.isRequired,
  entity: PropTypes.object,
  entityType: PropTypes.oneOf(['category', 'post']).isRequired,
  refersTo: PropTypes.string,
  paging: PropTypes.shape({
    currentPage: PropTypes.number,
    next: PropTypes.number,
    prev: PropTypes.number,
    total: PropTypes.number,
  }),
};

PageMetadata.defaultProps = {
  title: '',
  description: '',
  paging: {},
};

const mapRuntimeToProps = (state, ownProps, actions) => {
  return {
    isSite: isSite(state),
    renderSEOTags: actions.renderSEOTags,
  };
};

export default flowRight(connect(mapRuntimeToProps))(PageMetadata);
